export class DisplayStringArrayModel {
    stringArray: Array<string>;
}